
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Goatopimprichichwad() {



    const cardData =
    {
        keyword: 'Goa to Pimpri Chinchwad Cab',
        heading: 'S9 Travels: Goa to Pimpri Chinchwad Cab',
        headingDescription: 'S9 Travels offers Goa to Pimpri Chinchwad Cab Service, ensuring a comfortable, safe, and hassle-free journey. Whether you are returning from a beach vacation or traveling for business, our well-maintained cabs, including spacious Innova vehicles, provide a smooth and enjoyable ride. Enjoy on-time pickups, professional drivers, affordable pricing, and 24/7 service for a seamless travel experience. Book your Goa to Pimpri Chinchwad Cab with S9 Travels and travel stress-free with comfort and convenience!',


        top: 'Top Places to Visit in Pimpri Chinchwad with S9 Travels',

"topPlaces": [
    {
      "title": "Bhakti-Shakti Park",
      "description": "A well-maintained park featuring a grand statue of Chhatrapati Shivaji Maharaj and Sant Tukaram. It's a great spot for relaxation, evening walks, and enjoying the beautiful fountains and greenery."
    },
    {
      "title": "Auto Cluster Exhibition Center",
      "description": "An automotive museum and exhibition center, showcasing various vintage and modern automobiles. A must-visit place for car and bike enthusiasts."
    },
    {
      "title": "Appu Ghar",
      "description": "A popular amusement park in Nigdi, offering thrilling rides, a toy train, and fun activities for families and kids. It's often called the 'Disneyland of Pune.'"
    },
    {
      "title": "Bird Valley Udyan",
      "description": "A peaceful park featuring a large lake, jogging tracks, and play areas. Ideal for morning walks, birdwatching, and spending quality time with family."
    },
    {
      "title": "Durga Tekdi",
      "description": "A small hill offering a great trekking experience and panoramic views of Pimpri-Chinchwad. The lush greenery and fresh air make it a perfect place for nature lovers."
    },
    {
      "title": "Morya Gosavi Ganpati Temple",
      "description": "A historic temple dedicated to Lord Ganesha, built in honor of the famous saint Morya Gosavi. It is a revered pilgrimage site attracting devotees throughout the year."
    },
    {
      "title": "Nisargakavi Bahinabai Chaudhary Zoo",
      "description": "A small but well-maintained zoo housing various animals and birds. It's an excellent place for kids and nature enthusiasts to learn about wildlife."
    },
    {
      "title": "Science Park",
      "description": "An interactive science museum with various exhibits on space, energy, and robotics. The 3D planetarium and fun experiments make it a great educational spot for kids and adults alike."
    },
    {
      "title": "Thergaon Boat Club",
      "description": "A serene spot by the Pawana River offering boat rides, scenic views, and a peaceful atmosphere. Ideal for weekend relaxation and picnics."
    },
    {
      "title": "Gahunje Cricket Stadium (MCA Stadium)",
      "description": "A world-class cricket stadium hosting IPL and international matches. Cricket fans should check the schedule for live matches and enjoy the electrifying atmosphere."
    }
],

"services": [
  {
    "name": "Goa to Pimpri Chinchwad Cab Service",
    "description": "Book a reliable and comfortable cab from Goa to Pimpri Chinchwad with S9 Travels. Whether you're traveling for business, leisure, or a special occasion, we offer both one-way and round-trip services. Our professional drivers and well-maintained vehicles ensure that your journey is smooth, safe, and enjoyable."
  },
  {
    "name": "Book Goa to Pimpri Chinchwad Taxi",
    "description": "Booking a taxi from Goa to Pimpri Chinchwad is simple and hassle-free with S9 Travels. Whether you need a one-way trip or the flexibility of a round-trip, we provide reliable and timely taxi services. Our fleet of comfortable vehicles and experienced chauffeurs ensure a smooth and enjoyable journey."
  },
  {
    "name": "Affordable Goa to Pimpri Chinchwad Cab",
    "description": "Travel affordably from Goa to Pimpri Chinchwad with S9 Travels. We offer budget-friendly cab services that do not compromise on comfort or safety. Whether it's a one-way journey or a round trip, we ensure an affordable, stress-free, and reliable travel experience."
  },
  {
    "name": "Private Taxi for Pimpri Chinchwad from Goa",
    "description": "Travel privately and comfortably with a dedicated taxi from Goa to Pimpri Chinchwad. Our private taxis offer a personalized, uninterrupted travel experience, tailored to your needs. Choose from a variety of vehicles to suit your group size and preferences, ensuring a smooth and private ride."
  },
  {
    "name": "Goa to Pimpri Chinchwad One-Way or Round Trip",
    "description": "S9 Travels offers flexible one-way and round-trip taxi options for your journey from Goa to Pimpri Chinchwad. Whether you prefer a quick one-way trip or a round-trip service with the flexibility to explore, we offer the best solution for your travel needs, ensuring a safe and comfortable ride."
  },
  {
    "name": "Comfortable Taxi Ride from Goa to Pimpri Chinchwad",
    "description": "Experience a comfortable and relaxing taxi ride from Goa to Pimpri Chinchwad with S9 Travels. Our well-maintained vehicles and professional chauffeurs ensure that your journey is smooth, enjoyable, and stress-free, whether you’re traveling for business, leisure, or personal reasons."
  },
  {
    "name": "Luxury Cab for Goa to Pimpri Chinchwad",
    "description": "Indulge in luxury while traveling from Goa to Pimpri Chinchwad with S9 Travels. Our fleet of luxury cabs is equipped with premium amenities, offering the highest level of comfort, privacy, and style. Enjoy a premium ride with professional chauffeurs ensuring a smooth and luxurious travel experience."
  },
  {
    "name": "Group Travel from Goa to Pimpri Chinchwad by Taxi",
    "description": "Planning a group trip from Goa to Pimpri Chinchwad? S9 Travels offers spacious vehicles that can comfortably accommodate large groups. Whether you're traveling with family, friends, or colleagues, our taxis provide ample space and a smooth ride for everyone, ensuring that your group journey is enjoyable and comfortable."
  }
],

"tableData": [
  ["Goa to Pimpri Chinchwad Cab Service", "Book Goa to Pimpri Chinchwad Taxi"],
  ["Affordable Goa to Pimpri Chinchwad Cab", "Private Taxi for Pimpri Chinchwad from Goa"],
  ["Goa to Pimpri Chinchwad One-Way or Round Trip", "Comfortable Taxi Ride from Goa to Pimpri Chinchwad"],
  ["Luxury Cab for Goa to Pimpri Chinchwad", "Group Travel from Goa to Pimpri Chinchwad by Taxi"],
  ["", ""]
],





"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Reliable Long-Distance Travel",
    "WhyChoosedescription": "S9 Travels offers a comfortable Goa to Pimpri Chinchwad cab service, ideal for long-distance journeys. Our fleet of well-maintained vehicles, including the Toyota Innova, ensures a smooth, comfortable ride with ample space, air conditioning, and plush seating, making your trip enjoyable no matter the distance."
  },
  {
    "WhyChooseheading": "Timely and Dependable Service",
    "WhyChoosedescription": "We understand that timely travel is essential. Our Goa to Pimpri Chinchwad cab service ensures punctual pick-ups and drop-offs, so you can reach your destination on time without any delays. Whether you're traveling for business, leisure, or a special event, we guarantee reliable service every time."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our experienced drivers are familiar with the best routes and road conditions for trips from Goa to Pimpri Chinchwad. They prioritize safety, comfort, and efficiency, ensuring your journey is smooth and pleasant, no matter the destination."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable rates for the Goa to Pimpri Chinchwad cab service. We provide a transparent pricing structure with no hidden charges. You’ll receive a clear breakdown of the cost during the booking process, allowing you to plan your travel budget without surprises."
  },
  {
    "WhyChooseheading": "Safety and Comfort on Your Pimpri Chinchwad Journey",
    "WhyChoosedescription": "Your safety is our top priority. All our vehicles are equipped with modern safety features like GPS tracking, airbags, and seat belts to ensure a safe and comfortable journey for you and your passengers throughout your trip from Goa to Pimpri Chinchwad."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Scheduling",
    "WhyChoosedescription": "S9 Travels operates 24/7, offering flexible scheduling for your Goa to Pimpri Chinchwad trip. Whether you need an early morning departure or a late-night return, we’re here to provide reliable service that fits your travel schedule."
  },
  {
    "WhyChooseheading": "Customizable Itineraries for Your Pimpri Chinchwad Trip",
    "WhyChoosedescription": "We understand that every trip is unique. Whether you need to make stops along the way, have specific locations to visit, or require special arrangements, we offer customizable itineraries to suit your preferences and make your Goa to Pimpri Chinchwad journey even more enjoyable."
  },
  {
    "WhyChooseheading": "Simple and Hassle-Free Booking",
    "WhyChoosedescription": "Booking your Goa to Pimpri Chinchwad cab with S9 Travels is simple and hassle-free. You can easily book your ride online through our website or mobile app, or contact our customer service team for personalized assistance. We strive to make your booking process quick, easy, and convenient."
  }
]











    }

    const faqData = [
        [
          {
            question: 'How can I book a cab from Goa to Pimpri Chinchwad with S9 Travels?',
            answer: 'Booking a cab from Goa to Pimpri Chinchwad is easy! You can book your ride via our website, mobile app, or by contacting our customer service team for personalized assistance. We ensure a comfortable and hassle-free journey to Pimpri Chinchwad.',
          },
          {
            question: 'What types of vehicles are available for a trip from Goa to Pimpri Chinchwad?',
            answer: 'We offer a variety of vehicles for your trip from Goa to Pimpri Chinchwad, including sedans, SUVs, and premium vehicles like the Toyota Innova. Choose the vehicle that best suits your group size and travel preferences.',
          },
          {
            question: 'Are the drivers experienced for the Goa to Pimpri Chinchwad trip?',
            answer: 'Yes, our drivers are highly experienced and familiar with the best routes for the Goa to Pimpri Chinchwad journey. They prioritize your safety, comfort, and ensure a smooth travel experience.',
          },
          {
            question: 'Can I book a round-trip cab from Goa to Pimpri Chinchwad?',
            answer: 'Yes, you can book a round-trip cab for your journey from Goa to Pimpri Chinchwad. Simply provide us with your return details, and we will ensure a smooth and timely return journey.',
          },
          {
            question: 'How long in advance should I book a cab for Goa to Pimpri Chinchwad?',
            answer: 'It is recommended to book your cab at least 1-2 days in advance to ensure vehicle availability. However, last-minute bookings can also be accommodated depending on availability.',
          },
          {
            question: 'Is there a fixed fare for the Goa to Pimpri Chinchwad cab service?',
            answer: 'The fare for the Goa to Pimpri Chinchwad trip depends on the distance, vehicle type, and any special requests. Contact us for a personalized quote with transparent pricing based on your trip details.',
          },
          {
            question: 'Do you offer pick-up services from Goa airport or hotels for the Pimpri Chinchwad trip?',
            answer: 'Yes, we offer convenient pick-up services from Goa airport or hotels. Our professional drivers will ensure smooth transfer to your cab for a comfortable journey to Pimpri Chinchwad.',
          },
          {
            question: 'Can I request additional stops along the way during my trip to Pimpri Chinchwad?',
            answer: 'Yes, we can customize your itinerary to add stops for meals, sightseeing, or other breaks during your trip to Pimpri Chinchwad. Just let us know during booking to include your preferred stops.',
          },
          {
            question: 'Is there any extra charge for waiting or detours during the Goa to Pimpri Chinchwad trip?',
            answer: 'Any extra charges for waiting time or detours will be communicated to you upfront during the booking process. We ensure full transparency in our pricing.',
          },
          {
            question: 'Why should I choose S9 Travels for my Goa to Pimpri Chinchwad trip?',
            answer: 'S9 Travels offers reliable, safe, and comfortable cab services for your journey from Goa to Pimpri Chinchwad. With well-maintained vehicles, experienced drivers, and excellent customer service, we ensure a smooth and enjoyable trip.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Raghav Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab from Goa to Pimpri Chinchwad with S9 Travels, and it was an excellent experience. The vehicle was clean, and the driver was professional and friendly. The journey was comfortable and smooth. Highly recommend S9 Travels for anyone traveling long distances!”',
        },
        {
          name: 'Mrs. Shweta Kapoor',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our trip from Goa to Pimpri Chinchwad with S9 Travels was perfect. The vehicle was spacious, and the driver was friendly and experienced. We enjoyed the scenic route and had a very comfortable journey. We will definitely choose S9 Travels for our future travels!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Goa to Pimpri Chinchwad Cab",
        "description": "Book affordable and reliable Goa to Pimpri Chinchwad cab services for one-way trips, round trips, and luxury rides. S9 Travels offers private taxi services for a comfortable and scenic journey from Goa to Pimpri Chinchwad, perfect for group travel, sightseeing, and stress-free trips.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
      
      
      
      
      


    return (
        <div>
        <Helmet>
        <title>Goa to Pimpri Chinchwad Cab | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Goa to Pimpri Chinchwad taxi services, including one-way, round-trip, and private cabs. Comfortable and affordable transport for group travel, sightseeing, and trips from Goa to Pimpri Chinchwad with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/70.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Goatopimprichichwad;